import axios from 'axios';
import routes from './routes';
import { compact, isNumber, map } from 'lodash';

export const fetchParametros = () => (
  axios.get(routes.buscaCativo.parametros())
);

export const fetchReport = filtros => {
  const { atributos, cidades, cnaes, divisoesCNAE, estados, gruposCNAE, classesCNAE, ordenacao, regioes, sentidoOrdenacao, subgroups, submercados } = filtros;

  let params = {};

  if (submercados.length) params.submercados = map(submercados, 'id');
  if (regioes.length) params.regioes = map(regioes, 'id');
  if (estados.length) params.estados = map(estados, 'id');
  if (cidades.length) params.cidades = map(cidades, 'id');

  if (subgroups.length) params.subgroups = map(subgroups, 'id');
  if (divisoesCNAE.length) params.divisoesCNAE = map(divisoesCNAE, 'id');
  if (gruposCNAE.length) params.gruposCNAE = map(gruposCNAE, 'id');
  if (classesCNAE.length) params.classesCNAE = map(classesCNAE, 'id');
  if (cnaes.length) params.cnaes = map(cnaes, 'id');

  params.filtroValores = compact(map(atributos, ({ condicao, tipo, unidade, valor }) => {
    if (tipo && condicao && unidade && isNumber(valor)) {
      return ({
        atributo: tipo.id,
        condicao: condicao.id,
        unidade: unidade.id,
        valor,
      });
    } else {
      return false;
    }
  }));

  if (!params.filtroValores.length) delete params.filtroValores;

  if (ordenacao && sentidoOrdenacao) {
    params.ordenarPor = [{
  		atributo: ordenacao.id,
  		descendente: sentidoOrdenacao.id,
  	}];
  }

  return axios.post(routes.buscaCativo.fetch(), params);
};

export const fetchReportPage = (idRelatorio, pagina) => (
  axios.get(routes.buscaCativo.fetchNextPage(idRelatorio, pagina))
);

export const getRelatorioCSV = (idRelatorio, pagina) => (
  axios.get(routes.buscaCativo.getRelatorioCSV(idRelatorio, pagina))
);



// WEBPACK FOOTER //
// ./src/services/busca-cativo.js